// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3832":"49bd5ac6dac2f547","6214":"783503e670c84b29"}[chunkId] + ".js";
};